import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function TermsPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-2821">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2822">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2823">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2824">
            <Link to="/" data-id="element-2825">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2826" />
            </Link>
            <Navigation data-id="element-2827" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24" data-id="element-2828">
        <div className="max-w-4xl mx-auto" data-id="element-2829">
          <h1 className="text-5xl md:text-6xl font-bold mb-16 font-['Syne'] text-black" data-id="element-2830">
            TERMS OF SERVICES
          </h1>

          <div className="space-y-12 font-['Lora'] text-gray-800 leading-relaxed" data-id="element-2831">
            <section data-id="element-2832">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2833">
                1. Overview
              </h2>
              <p className="text-lg mb-4" data-id="element-2834">
                Welcome to MeetSynthia.ai ("Synthia," "we," "us," or "our").
                These Terms and Conditions ("Terms") govern your access to and
                use of our website, products, and services (collectively, the
                "Platform").
              </p>
              <p className="text-lg" data-id="element-2835">
                By accessing or using the Platform, you agree to be bound by
                these Terms and our Privacy Policy. If you do not agree,
                discontinue use immediately.
              </p>
            </section>

            <section data-id="element-2836">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2837">
                2. Nature of the Service
              </h2>
              <p className="text-lg mb-4" data-id="element-2838">
                MeetSynthia.ai provides an AI-driven instruction layer that
                augments, governs, and optimizes user and agentic inputs ("prompts") for
                compatibility with large language models ("LLMs").
              </p>
              <p className="text-lg mb-4" data-id="element-2839">
                Synthia operates exclusively at the instruction layer. We do not
                generate, produce, or provide final AI outputs. All generative
                content, answers, and responses are produced entirely by
                external frontier AI models (e.g., OpenAI, Anthropic, Google, or
                your chosen enterprise LLM).
              </p>
              <p className="text-lg" data-id="element-2840">
                Synthia's role is limited to preparing, governing, structuring,
                and verifying prompt instructions using configurable
                "guardrails," "attributes," "roles," and "workflows."
              </p>
            </section>

            <section data-id="element-2841">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2842">
                3. No Responsibility for AI Output
              </h2>
              <p className="text-lg mb-4" data-id="element-2843">
                Because Synthia operates solely at the instruction layer and
                does not produce final answers, you explicitly acknowledge and
                agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2844">
                <li data-id="element-2845">
                  Synthia is not responsible for any content, answers, or
                  outputs generated by third-party AI systems.
                </li>
                <li data-id="element-2846">
                  Synthia makes no warranties, representations, or guarantees as
                  to the accuracy, completeness, legality, reliability, safety,
                  or appropriateness of AI-generated outputs.
                </li>
                <li data-id="element-2847">
                  Synthia cannot and does not make claims regarding security,
                  PII handling, bias mitigation, or factual accuracy of final
                  outputs—these are determined entirely by the frontier LLM
                  provider.
                </li>
                <li data-id="element-2848">
                  You agree to independently review, verify, and validate all
                  AI-generated results before use, publication, or reliance.
                </li>
                <li data-id="element-2849">
                  Any issues related to output quality, hallucinations, bias,
                  toxicity, or compliance violations are the sole responsibility
                  of the AI model provider and the user.
                </li>
              </ul>
            </section>

            <section data-id="element-2850">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2851">
                4. Enterprise Hosting and Data Handling
              </h2>
              <p className="text-lg mb-4" data-id="element-2852">
                When deployed in an enterprise environment, Synthia may be
                hosted:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2853">
                <li data-id="element-2854">
                  Privately within the client's infrastructure (self-hosted,
                  on-premises, or VPC), or
                </li>
                <li data-id="element-2855">In Synthia's secure managed cloud environment.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2856">In both cases:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2857">
                <li data-id="element-2858">
                  The enterprise retains full ownership of its data, prompts,
                  guardrails, workflows, and all proprietary configurations.
                </li>
                <li data-id="element-2859">
                  Synthia processes data solely for the purpose of providing,
                  improving, and supporting the Platform.
                </li>
                <li data-id="element-2860">
                  Synthia will never sell, monetize, or use client data for
                  model training, marketing, or competitive purposes.
                </li>
                <li data-id="element-2861">
                  Client-specific proprietary information, including custom
                  guardrails, unique workflows, domain expertise, and
                  institutional knowledge extracted from your organization, will
                  never be shared with third parties or other customers.
                </li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2862">
                Data sharing with third parties occurs only:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2863">
                <li data-id="element-2864">With the client's explicit written consent, or</li>
                <li data-id="element-2865">As required by law, court order, or lawful subpoena.</li>
              </ul>
            </section>

            <section data-id="element-2866">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2867">
                5. Marketplace and Contextual Intelligence Catalog
              </h2>
              <p className="text-lg mb-4" data-id="element-2868">
                Synthia operates a marketplace of contextual intelligence that
                includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2869">
                <li data-id="element-2870">
                  Pre-built guardrails, roles, attributes, and workflows
                  developed by Synthia.
                </li>
                <li data-id="element-2871">Community-contributed and third-party components.</li>
                <li data-id="element-2872">Industry best practices and common governance patterns.</li>
              </ul>

              <p className="text-lg mt-4 mb-2" data-id="element-2873">
                You acknowledge and agree that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2874">
                <li data-id="element-2875">
                  Best practices, industry standards, and common governance
                  patterns naturally overlap across organizations and cannot be
                  considered proprietary to any single client.
                </li>
                <li data-id="element-2876">
                  While your proprietary and confidential information will never
                  be shared, Synthia may develop similar or related guardrails,
                  workflows, or governance patterns for other clients based on
                  industry knowledge, public information, and independent
                  development.
                </li>
                <li data-id="element-2877">
                  No client has exclusive rights to general concepts,
                  approaches, or methodologies in AI governance.
                </li>
                <li data-id="element-2878">
                  The marketplace may contain components similar to those
                  developed for your organization, reflecting common industry
                  needs rather than disclosure of your proprietary information.
                </li>
                <li data-id="element-2879">
                  You cannot claim ownership or exclusive rights over
                  industry-standard practices, common use cases, or generally
                  applicable governance frameworks.
                </li>
                <li data-id="element-2880">
                  Synthia commits that any components in the marketplace derived
                  from work with specific clients will be sufficiently
                  abstracted and generalized to remove client-specific
                  proprietary information, trade secrets, and confidential
                  business logic.
                </li>
              </ul>
            </section>

            <section data-id="element-2881">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2882">
                6. License and Acceptable Use
              </h2>
              <p className="text-lg mb-4" data-id="element-2883">
                You are granted a limited, revocable, non-exclusive license to
                use the Platform for internal business purposes. You may not:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2884">
                <li data-id="element-2885">
                  Use the Platform for unlawful, infringing, or harmful
                  activity.
                </li>
                <li data-id="element-2886">
                  Reverse engineer, decompile, or modify any part of the
                  Platform.
                </li>
                <li data-id="element-2887">
                  Attempt to access another customer's data, configurations, or
                  restricted systems.
                </li>
                <li data-id="element-2888">
                  Use the Platform to generate content that violates applicable
                  laws or third-party rights.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2889">
                We reserve the right to suspend or terminate access for
                violations of these Terms.
              </p>
            </section>

            <section data-id="element-2890">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2891">
                7. Intellectual Property
              </h2>
              <p className="text-lg mb-4" data-id="element-2892">
                All intellectual property in the Platform, including software,
                base guardrail logic, BrandKey™ technology, visual interfaces,
                documentation, and core architecture, belongs to MeetSynthia,
                Inc. or its licensors.
              </p>
              <p className="text-lg mb-2" data-id="element-2893">Users retain ownership of:</p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2894">
                <li data-id="element-2895">Their original data and prompts.</li>
                <li data-id="element-2896">Custom guardrails and configurations they create.</li>
                <li data-id="element-2897">Proprietary workflows and institutional knowledge.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2898">
                By using the Platform, you grant Synthia a limited,
                non-exclusive right to process, host, and analyze your
                configurations solely to provide and improve the service. This
                license terminates upon account closure, subject to retention
                periods specified in our Privacy Policy.
              </p>
            </section>

            <section data-id="element-2899">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2900">
                8. Third-Party Integrations
              </h2>
              <p className="text-lg mb-4" data-id="element-2901">
                Synthia integrates with external AI providers and enterprise
                systems at your direction. You acknowledge that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2902">
                <li data-id="element-2903">
                  We are not responsible for third-party systems, their
                  availability, performance, uptime, or outputs.
                </li>
                <li data-id="element-2904">
                  You must comply with all applicable third-party terms of
                  service (e.g., OpenAI API Terms, Anthropic Terms, Google Cloud
                  Terms).
                </li>
                <li data-id="element-2905">
                  Any issues with AI model performance, availability, or outputs
                  must be addressed with the respective provider.
                </li>
              </ul>
            </section>

            <section data-id="element-2906">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2907">
                9. Disclaimers
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2908">
                THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                WARRANTY OF ANY KIND.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2909">
                WE EXPRESSLY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED,
                INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, ACCURACY,
                RELIABILITY, OR SECURITY.
              </p>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2910">
                NO ADVICE OR INFORMATION OBTAINED FROM SYNTHIA SHALL CREATE ANY
                WARRANTY NOT EXPRESSLY STATED IN THESE TERMS.
              </p>
              <p className="text-lg uppercase font-bold" data-id="element-2911">
                ALL AI OUTPUTS MUST BE REVIEWED BY QUALIFIED HUMANS BEFORE USE.
                AUTOMATED RELIANCE ON AI OUTPUTS IS DONE AT YOUR SOLE RISK.
              </p>
            </section>

            <section data-id="element-2912">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2913">
                10. Limitation of Liability
              </h2>
              <p className="text-lg mb-4 uppercase font-bold" data-id="element-2914">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2915">
                <li data-id="element-2916">
                  MeetSynthia shall not be liable for any indirect, incidental,
                  consequential, special, exemplary, or punitive damages,
                  including but not limited to loss of profits, data, use,
                  goodwill, or other intangible losses.
                </li>
                <li data-id="element-2917">
                  Our total aggregate liability for any claim shall not exceed
                  the total amount paid to MeetSynthia in the six (6) months
                  immediately preceding the claim, or $100 USD, whichever is
                  greater.
                </li>
                <li data-id="element-2918">
                  This limitation applies regardless of the theory of liability
                  (contract, tort, negligence, strict liability, or otherwise)
                  and even if we have been advised of the possibility of such
                  damages.
                </li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2919">
                Given that Synthia operates solely at the instruction layer and
                all outputs are produced by third-party AI systems, MeetSynthia
                cannot be held responsible for any damages resulting from
                AI-generated content, including but not limited to
                misinformation, bias, harmful content, privacy violations,
                regulatory non-compliance, or financial losses.
              </p>
            </section>

            <section data-id="element-2920">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2921">
                11. Indemnification
              </h2>
              <p className="text-lg mb-4" data-id="element-2922">
                You agree to indemnify, defend, and hold harmless MeetSynthia,
                its affiliates, officers, directors, employees, agents, and
                licensors from and against any and all claims, liabilities,
                damages, losses, costs, expenses, or fees (including reasonable
                attorneys' fees) arising from:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2923">
                <li data-id="element-2924">Your use or misuse of the Platform.</li>
                <li data-id="element-2925">Your violation of these Terms.</li>
                <li data-id="element-2926">Your violation of any rights of another party.</li>
                <li data-id="element-2927">
                  Content generated by third-party AI systems that you deploy,
                  publish, or rely upon.
                </li>
                <li data-id="element-2928">
                  Any breach of your representations or warranties herein.
                </li>
              </ul>
            </section>

            <section data-id="element-2929">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2930">
                12. Compliance with Data Protection Laws
              </h2>
              <p className="text-lg mb-4" data-id="element-2931">
                Each party shall comply with all applicable data protection
                laws, including but not limited to the General Data Protection
                Regulation (GDPR), California Consumer Privacy Act (CCPA),
                Health Insurance Portability and Accountability Act (HIPAA)
                where applicable, and other relevant frameworks.
              </p>
              <p className="text-lg" data-id="element-2932">
                When Synthia acts as a data processor, we process data only
                under the written instructions of the data controller (the
                client). Clients are responsible for ensuring their use of the
                Platform complies with all applicable regulations.
              </p>
            </section>

            <section data-id="element-2933">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2934">
                13. Termination
              </h2>
              <p className="text-lg mb-4" data-id="element-2935">
                MeetSynthia may suspend or terminate your access at any time
                for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-lg" data-id="element-2936">
                <li data-id="element-2937">Violation of these Terms.</li>
                <li data-id="element-2938">Non-payment of fees.</li>
                <li data-id="element-2939">Engagement in fraudulent, harmful, or illegal activity.</li>
                <li data-id="element-2940">Court order or legal requirement.</li>
              </ul>
              <p className="text-lg mt-4" data-id="element-2941">
                Upon termination, you must immediately cease all use of the
                Platform. Data retention and deletion procedures are governed by
                our Privacy Policy and any applicable Data Processing Agreement.
              </p>
            </section>

            <section data-id="element-2942">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2943">
                14. Governing Law and Dispute Resolution
              </h2>
              <p className="text-lg mb-4" data-id="element-2944">
                These Terms are governed by and construed in accordance with the
                laws of the State of Delaware, United States, without regard to
                its conflict of law provisions.
              </p>
              <p className="text-lg" data-id="element-2945">
                Any disputes arising from or relating to these Terms or the
                Platform shall be resolved exclusively in the state or federal
                courts located in Delaware. You consent to the personal
                jurisdiction of such courts.
              </p>
            </section>

            <section data-id="element-2946">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2947">
                15. Changes to Terms
              </h2>
              <p className="text-lg mb-4" data-id="element-2948">
                We reserve the right to modify these Terms at any time. Changes
                will be effective upon posting to the website with a new "Last
                Updated" date. Your continued use of the Platform after changes
                are posted constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section data-id="element-2949">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2950">
                16. Severability
              </h2>
              <p className="text-lg" data-id="element-2951">
                If any provision of these Terms is found to be unenforceable or
                invalid, that provision shall be limited or eliminated to the
                minimum extent necessary, and the remaining provisions shall
                remain in full force and effect.
              </p>
            </section>

            <section data-id="element-2952">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2953">
                17. Entire Agreement
              </h2>
              <p className="text-lg" data-id="element-2954">
                These Terms, together with our Privacy Policy and any applicable
                Data Processing Agreement, constitute the entire agreement
                between you and MeetSynthia regarding the Platform and supersede
                all prior or contemporaneous understandings and agreements.
              </p>
            </section>

            <section data-id="element-2955">
              <h2 className="text-3xl font-bold mb-4 font-['Syne'] text-black" data-id="element-2956">
                18. Contact
              </h2>
              <p className="text-lg mb-4" data-id="element-2957">For questions about these Terms:</p>
              <p className="text-lg" data-id="element-2958">📧 legal@meetsynthia.ai</p>
              <p className="text-lg mt-4" data-id="element-2959">
                MeetSynthia, Inc.
                <br data-id="element-2960" />
                Wilmington, Delaware, USA
              </p>
              <p className="text-lg mt-6" data-id="element-2961">Last Updated: December 26, 2024</p>
            </section>
          </div>
        </div>
      </main>

      <Footer data-id="element-2962" />
    </div>;
}